// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__-az9K","loaderOuter":"PageOverlayLoader_loaderOuter__3rPtS"};